import { useLocale } from 'src/lib/hooks/useLocal'
import Switch from '@mui/material/Switch'
import { useRtoSuiteContext } from 'src/lib/contexts/RTOSuiteProvider'
import { useRTOSuitePermissions } from 'src/lib/access-permission-hooks/useRTOSuitePermissions'

const MandatoryOtp = () => {
  const mandatoryOTPEnabled = useRtoSuiteContext(context => context.state?.mandatoryOtpEnabled)
  const setMandatoryOTP = useRtoSuiteContext(context => context.actions?.setMandatoryOTP)
  const { canEditRTOSuite } = useRTOSuitePermissions()

  const { t } = useLocale()
  return (
    <div className='flex flex-row justify-between pb-4' data-track-id='mandatory-otp-on-login-header'>
      <div className='flex flex-col gap-1 text-sm'>
        <h2 className='font-medium text-carbon'>{t('mandatory_otp_on_login')}</h2>
        <p className='font-normal leading-5 text-gray-dark'>{t('mandatory_otp_description')}</p>
      </div>
      <Switch
        disabled={!canEditRTOSuite}
        checked={mandatoryOTPEnabled}
        onChange={() => {
          setMandatoryOTP(!mandatoryOTPEnabled)
        }}
      />
    </div>
  )
}

export default MandatoryOtp
